module.exports = __webpack_public_path__ + "static/media/iconSurvey.4b4ef779.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/Icons/iconSurvey.svg
// module id = 350
// module chunks = 0